import { Link as GatsbyLink } from 'gatsby-plugin-intl';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AnimateHeight from 'react-animate-height';
import MenuPlusIcon from '../icons/menuPlus.svg';
import MenuMinusIcon from '../icons/navMinus.svg';

import * as styles from './menuGroup.module.css';

const Link = ({ path, name, activeClassName }) => {
  if (path.startsWith('https://')) {
    return (
      <a className={styles.link} href={path}>
        {name}
      </a>
    );
  } else {
    return (
      <GatsbyLink
        activeClassName={activeClassName}
        className={styles.link}
        to={path}
      >
        {name}
      </GatsbyLink>
    );
  }
};
Link.propTypes = {
  path: PropTypes.string,
  name: PropTypes.string,
  activeClassName: PropTypes.string,
};

export const MenuLink = ({ activeClassName, name, path }) => (
  <div key={name} className={styles.linkContainer}>
    <Link activeClassName={activeClassName} name={name} path={path} />
  </div>
);
MenuLink.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  activeClassName: PropTypes.string,
};

class MenuGroup extends Component {
  state = {
    height: 0,
  };

  toggle = () => {
    const { height } = this.state;

    this.setState({
      height: height === 0 ? 'auto' : 0,
    });
  };
  render() {
    const { height } = this.state;
    const { title, links } = this.props;
    return (
      <div>
        <div className={styles.menuGroup}>
          <div className={styles.menuGroupHeader} onClick={() => this.toggle()}>
            <div className={styles.plusIconContainer}>
              {height === 'auto' ? <MenuMinusIcon /> : <MenuPlusIcon />}
            </div>

            <div className={styles.menuGroupText}>{title}</div>
          </div>
          <AnimateHeight duration={400} height={height}>
            {links.list.map(link => (
              <MenuLink key={link.path} name={link.name} path={link.path} />
            ))}
          </AnimateHeight>
        </div>
      </div>
    );
  }
}

export default MenuGroup;

MenuGroup.propTypes = {
  title: PropTypes.string,
  links: PropTypes.object,
};
